import * as React from 'react';
import { cn } from '../../lib/utils';

/**
 * Accessible toggle Switch (dependency-free; role="switch"). Token-driven via
 * base.css so it follows light/dark and any palette change automatically.
 */
export interface SwitchProps {
  checked: boolean;
  onCheckedChange: (v: boolean) => void;
  disabled?: boolean;
  id?: string;
  className?: string;
  'aria-label'?: string;
}

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ checked, onCheckedChange, disabled, className, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onCheckedChange(!checked)}
      className={cn(
        'relative inline-flex h-[18px] w-[32px] flex-shrink-0 cursor-pointer items-center rounded-full transition-colors duration-fast focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        checked ? 'bg-primary' : 'bg-border-strong',
        className
      )}
      {...props}
    >
      <span
        className={cn(
          'pointer-events-none block h-[14px] w-[14px] rounded-full bg-white shadow-sm transition-transform duration-fast',
          checked ? 'translate-x-[16px]' : 'translate-x-[2px]'
        )}
      />
    </button>
  )
);
Switch.displayName = 'Switch';
